import './grid-loader.css';

// @vue/component
export const GridLoader = {
	template: `
		<div class="tasks-template-history-grid-loader-spinner-container">
			<div class="tasks-template-history-grid-loader-spinner"/>
		</div>
	`,
};
